import { useSelector } from "react-redux";
import axios from "axios";

const axiosInstance = axios.create({});
//unauthorize
const unAuth = () => {
  const api = (method, url, data, params) => {
    return axiosInstance({
      method: method,
      url: url,
      data: data || null,
      headers: {
        Authorization: null,
      },
      params: params || null,
    });
  };

  return api;
};
const useApi = () => {
  const token = useSelector((state) => state.auth.token);
  const api = (method, url, data, params) => {
    return axiosInstance({
      method: method,
      url: url,
      data: data || null,
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
      params: params || null,
    });
  };

  return api;
};

export default { useApi, unAuth };
